<section class="cart-wrapper">
  <app-cart-layout
    *ngIf="cart"
    [cart]="cart"
    (reloadCart)="reloadCart()"
  ></app-cart-layout>
  <app-empty-cart-layout *ngIf="cart == null"></app-empty-cart-layout>
</section>
